import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { DocumentTitle } from 'src/routes/components';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

// ----------------------------------------------------------------------

const EventsTrialLanding = lazy(() => import('src/pages/events-trial/landing'));

export function getEventsTrialRoutes(): RouteObject[] {
  return [
    {
      path: 'events-trial',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <>
            <DocumentTitle />
            <EventsTrialLanding />
          </>
        </Suspense>
      ),
    },
  ];
}
